(() => {
  'use strict';
  if (window.sdJournalViewsLoaded) return;
  window.sdJournalViewsLoaded = true;
  const ENDPOINT = 'https://sawasdeal-journal-counter.zlota-cn.workers.dev';
  const nodes = [...document.querySelectorAll('[data-sd-views-id]')];
  if (!nodes.length || window.Shopify?.designMode) return;
  const ids = [...new Set(nodes.map(el => el.dataset.sdViewsId))];
  const totals = new Map();
  const state = value => nodes.forEach(el => { el.dataset.sdViewsState = value; });
  const article = document.querySelector('[data-sd-reading-article]');
  let activeController, completed = false, requesting = false, retries = 0, retryTimer;
  // Fresh in-memory ID per opening; refresh counts again. Retries are one opening.
  let eventId = crypto.randomUUID();
  function processingAllowed() {
    try {
      return navigator.globalPrivacyControl !== true && navigator.doNotTrack !== '1' &&
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true;
    } catch { return false; }
  }
  function display(id, value) {
    if (!Number.isSafeInteger(value) || value < 0) return;
    value = Math.max(value, totals.get(id) || 0);
    totals.set(id, value);
    nodes.filter(el => el.dataset.sdViewsId === id).forEach(el => {
      const number = el.querySelector('[data-sd-view-number]');
      if (number) number.textContent = value.toLocaleString('en-US');
      el.hidden = false;
    });
  }
  async function json(path, options = {}, analytics = true) {
    if (analytics && !processingAllowed()) throw new Error('not allowed');
    const response = await fetch(ENDPOINT + path, {
      mode: 'cors', credentials: 'omit', referrerPolicy: 'no-referrer',
      signal: analytics ? activeController.signal : undefined, ...options
    });
    if (!response.ok) throw new Error('unavailable');
    return response.json();
  }
  async function loadCounts() {
    for (let offset = 0; offset < ids.length; offset += 40) {
      try {
        // Public aggregate display is separate from recording a visit.
        const data = await json('/counts?ids=' + encodeURIComponent(ids.slice(offset, offset + 40).join(',')), {}, false);
        Object.entries(data.counts || {}).forEach(([id, value]) => display(id, value));
      } catch { state('counts-unavailable'); }
    }
  }
  async function recordView() {
    if (!article || completed || requesting || retries > 2 || !processingAllowed()) return;
    if (!activeController || activeController.signal.aborted) activeController = new AbortController();
    requesting = true;
    try {
      const data = await json('/view', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: article.dataset.sdReadingArticle, eventId, consent: true })
      });
      display(String(data.id), data.views);
      completed = true;
      state('page-view-recorded');
    } catch {
      retries++;
      if (processingAllowed() && retries <= 2) retryTimer = window.setTimeout(recordView, retries * 1500);
    } finally { requesting = false; }
  }
  function syncConsent() {
    if (!processingAllowed()) {
      activeController?.abort();
      window.clearTimeout(retryTimer);
      state('analytics-disabled');
      return;
    }
    state(completed ? 'page-view-recorded' : 'analytics-allowed');
    void recordView();
  }
  document.addEventListener('visitorConsentCollected', syncConsent);
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    eventId = crypto.randomUUID(); completed = false; retries = 0;
    window.clearTimeout(retryTimer);
    void loadCounts(); syncConsent();
  });
  state('loading-privacy-api');
  void loadCounts();
  if (window.Shopify?.customerPrivacy) syncConsent();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) syncConsent();
    });
  }
})();
